import React from 'react';

export default function CircleNumber({
	number,
	variant = 'filled'
}: {
	number: number;
	variant?: 'filled' | 'outlined' | 'gray' | 'disabled';
}) {
	return (
		<div
			className={`flex h-full w-full items-center justify-center rounded-full font-bold ${variant === 'filled' ? 'bg-orange text-dm-black' : ''} ${variant === 'outlined' ? 'border border-orange text-orange' : ''} ${variant === 'gray' ? 'border border-dm-mid-grey text-dm-mid-grey' : ''} ${variant === 'disabled' ? 'border border-dm-grey text-dm-grey' : ''}`}
		>
			{number}
		</div>
	);
}
